import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import "@app/styles/index.css";
import "baby-i-am-faded/styles.css";
import NextNprogress from "nextjs-progressbar";
import { SessionProvider, signIn, useSession } from "next-auth/react";
import { ThemeProvider } from "next-themes";
import { useEffect } from "react";
import { useRouter } from "next/router";
import { AppError } from "@app/utils/errors";
import { Toaster } from "react-hot-toast";
import { BeskarProvider } from "beskar/src/BeskarProvider";
import { NextUiStuff } from "beskar/src/nextui";
import React from "react";
import Script from "next/script";
import { env } from "@app/env";
import { getSubscription } from "./api/functions";
import { useSignupConversion, useSignupReason } from "@app/utils/conversions";
var MyDashboardLayout = /*#__PURE__*/ React.lazy(function() {
    return import("../components/MyDashboardLayout");
});
function MyApp(_param) {
    var Component = _param.Component, session = _param.pageProps.session, pageProps = _object_without_properties(_param.pageProps, [
        "session"
    ]);
    var router = useRouter();
    var isDashboard = router.asPath.startsWith("/board");
    console.log("_app rendering");
    // const updateUpgradeModal = useUpdateAtom(atomUpgradeModal)
    useEffect(function() {
        if (env.NEXT_PUBLIC_ENV !== "production") {
            window.loginForTests = function() {
                var _ref = _async_to_generator(function(param) {
                    var name, email;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                name = param.name, email = param.email;
                                if (!email) {
                                    throw new AppError("Email is required for test provider");
                                }
                                return [
                                    4,
                                    signIn("test-provider", {
                                        name: name,
                                        email: email,
                                        callbackUrl: "/empty",
                                        redirect: false
                                    })
                                ];
                            case 1:
                                // const providers = await getProviders()
                                // console.log({ providers })
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
                return function(_) {
                    return _ref.apply(this, arguments);
                };
            }();
        }
    }, []);
    // const forcedTheme = !isDashboard ? 'light' : undefined
    return /*#__PURE__*/ _jsxs(SessionProvider, {
        session: session,
        children: [
            /*#__PURE__*/ _jsx(Script, {
                async: true,
                src: "https://cdn.splitbee.io/sb.js"
            }),
            /*#__PURE__*/ _jsx(Script, {
                id: "crisp",
                // defer
                type: "text/javascript",
                children: 'window.$crisp=[];window.CRISP_WEBSITE_ID="f1fe71b4-e988-4f87-8030-2bdb2d9c5176";(function(){d=document;s=d.createElement("script");s.src="https://client.crisp.chat/l.js";s.async=1;d.getElementsByTagName("head")[0].appendChild(s);})();'
            }),
            /*#__PURE__*/ _jsx(Script, {
                async: true,
                src: "https://reflio.com/js/reflio.min.js",
                "data-reflio": "oyvmpkzb0wdqp5d"
            }),
            /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Script, {
                        src: "https://notaku.so/widget.js?widgetId=clae08wvt53490enfb9kl2b71v",
                        "data-widget-id": "clae08wvt53490enfb9kl2b71v",
                        async: true
                    }),
                    /*#__PURE__*/ _jsx(Script, {
                        src: "https://notaku.so/widget.js?widgetId=claehjgp44412eni36xe3oawi",
                        "data-widget-id": "claehjgp44412eni36xe3oawi",
                        async: true
                    }),
                    /*#__PURE__*/ _jsx(Script, {
                        src: "https://notaku.so/widget.js?widgetId=claf889976052enifeb1diqnl",
                        "data-widget-id": "claf889976052enifeb1diqnl",
                        async: true
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(SignupConversionComponent, {}),
            /*#__PURE__*/ _jsx(BeskarProvider, {
                children: /*#__PURE__*/ _jsxs(ThemeProvider, {
                    defaultTheme: "dark",
                    enableSystem: false,
                    attribute: "class",
                    children: [
                        /*#__PURE__*/ _jsx(Toaster, {
                            containerStyle: {
                                zIndex: 10000
                            },
                            position: "top-center"
                        }),
                        /*#__PURE__*/ _jsx(InjectCrispEmail, {}),
                        /*#__PURE__*/ _jsx(NextNprogress, {
                            color: "#29D",
                            startPosition: 0.3,
                            stopDelayMs: 200,
                            height: 4,
                            options: {
                                showSpinner: false
                            },
                            showOnShallow: true
                        }),
                        /*#__PURE__*/ _jsx(NextUiStuff, {
                            children: isDashboard ? /*#__PURE__*/ _jsx(MyDashboardLayout, {
                                fullWidth: !!Component.fullWidth,
                                Tabs: Component.Tabs,
                                children: /*#__PURE__*/ _jsx(Component, _object_spread({}, pageProps))
                            }) : /*#__PURE__*/ _jsx(Component, _object_spread({}, pageProps))
                        })
                    ]
                })
            })
        ]
    });
}
export default MyApp;
function InjectCrispEmail() {
    var ref = useSession(), session = ref.data;
    useEffect(function() {
        var ref;
        var email = session === null || session === void 0 ? void 0 : (ref = session.user) === null || ref === void 0 ? void 0 : ref.email;
        if (!email) {
            return;
        }
        if (!window.$crisp) {
            console.warn("Cannot set Crisp email, Crisp not loaded");
            return;
        }
        window.$crisp.push([
            "set",
            "user:email",
            email
        ]);
    }, [
        session
    ]);
    var router = useRouter();
    var orgId = router.query.orgId;
    // set user segments
    useEffect(function() {
        if (!orgId || !session) {
            return;
        }
        setTimeout(/*#__PURE__*/ _async_to_generator(function() {
            var ref, subscription, freeTrial, value, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            getSubscription({
                                orgId: orgId
                            })
                        ];
                    case 1:
                        ref = _state.sent(), subscription = ref.subscription, freeTrial = ref.freeTrial;
                        if (subscription && !freeTrial) {
                            console.log("Setting Crisp segment to 'paying-user'");
                            $crisp.push([
                                "set",
                                "session:segments",
                                [
                                    [
                                        "paying-user"
                                    ]
                                ]
                            ]);
                            value = (subscription === null || subscription === void 0 ? void 0 : subscription.unit_amount) || "";
                            $crisp.push([
                                "set",
                                "session:data",
                                [
                                    [
                                        [
                                            "user-plan",
                                            "$" + value
                                        ]
                                    ]
                                ]
                            ]);
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        console.error(error);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        }), 1000);
    }, [
        session,
        orgId
    ]);
    return null;
}
function SignupConversionComponent() {
    useSignupConversion();
    useSignupReason({});
    return null;
}
